import { render, staticRenderFns } from "./ComponentLoginTrades.vue?vue&type=template&id=f6676018&scoped=true"
import script from "./ComponentLoginTrades.vue?vue&type=script&lang=js"
export * from "./ComponentLoginTrades.vue?vue&type=script&lang=js"
import style0 from "./ComponentLoginTrades.vue?vue&type=style&index=0&id=f6676018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6676018",
  null
  
)

export default component.exports